export function errMsg(e, fallback = "Something went wrong — please try again") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string" && d) return d;
  if (Array.isArray(d) && d.length) return d.map(x => x?.msg || String(x)).join(", ");
  if (d && typeof d === "object" && d.msg) return d.msg;
  return fallback;
}
